import Vue from 'vue'

Vue.filter('numberk', function (num) {
  let res = Math.sign(num) * Math.abs(num);
  if (Math.abs(num) > 999999999) {
    res = Math.sign(num)*((Math.abs(num)/1000000000).toFixed(1)) + 'B'
  } else if (Math.abs(num) > 999999) {
    res = Math.sign(num)*((Math.abs(num)/1000000).toFixed(1)) + 'M'
  } else if (Math.abs(num) > 999) {
    res = Math.sign(num)*((Math.abs(num)/1000).toFixed(1)) + 'K'
  }
  return res
})
